import { render, staticRenderFns } from "./dashboards_lista.vue?vue&type=template&id=4dd0d711&"
import script from "./dashboards_lista.vue?vue&type=script&lang=ts&"
export * from "./dashboards_lista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports